var _path, _path2, _circle, _mask, _path3, _path4, _circle2, _mask2, _path5, _path6, _circle3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 13.7869L35.4044 4.744C35.7599 4.60234 36.1561 4.60191 36.5119 4.74279L59.2788 13.7575C59.8509 13.984 60.2266 14.5369 60.2266 15.1522V36.0024C60.2266 48.0624 49.8001 62.785 36.3838 67.3409C36.1071 67.4348 35.8101 67.4419 35.53 67.3586C23.4059 63.7499 11.7658 48.9309 11.7767 35.1905L11.7662 15.1811C11.7658 14.5667 12.1402 14.0143 12.7109 13.7869Z",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1777 21.7266L50.8211 21.89",
    stroke: "#161614",
    strokeWidth: 3.19316,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5234,
    cy: 21.8926,
    r: 4.05664,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_75_1436",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5801 21.8926C52.5801 24.133 50.7639 25.9492 48.5234 25.9492C46.283 25.9492 44.4668 24.133 44.4668 21.8926C44.4668 19.6522 46.283 17.8359 48.5234 17.8359C50.7639 17.8359 52.5801 19.6522 52.5801 21.8926ZM46.4951 21.8926C46.4951 23.0128 47.4032 23.9209 48.5234 23.9209C49.6436 23.9209 50.5518 23.0128 50.5518 21.8926C50.5518 20.7724 49.6436 19.8643 48.5234 19.8643C47.4032 19.8643 46.4951 20.7724 46.4951 21.8926Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5801 21.8926C52.5801 24.133 50.7639 25.9492 48.5234 25.9492C46.283 25.9492 44.4668 24.133 44.4668 21.8926C44.4668 19.6522 46.283 17.8359 48.5234 17.8359C50.7639 17.8359 52.5801 19.6522 52.5801 21.8926ZM46.4951 21.8926C46.4951 23.0128 47.4032 23.9209 48.5234 23.9209C49.6436 23.9209 50.5518 23.0128 50.5518 21.8926C50.5518 20.7724 49.6436 19.8643 48.5234 19.8643C47.4032 19.8643 46.4951 20.7724 46.4951 21.8926Z",
    fill: "#161614",
    stroke: "#161614",
    strokeWidth: 0.162266,
    mask: "url(#path-4-inside-1_75_1436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1777 45.1172L50.8211 45.2806",
    stroke: "#161614",
    strokeWidth: 3.19316,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 45.2832,
    r: 4.05664,
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_75_1436",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0566 45.2832C43.0566 47.5236 41.2404 49.3398 39 49.3398C36.7596 49.3398 34.9434 47.5236 34.9434 45.2832C34.9434 43.0428 36.7596 41.2266 39 41.2266C41.2404 41.2266 43.0566 43.0428 43.0566 45.2832ZM36.9717 45.2832C36.9717 46.4034 37.8798 47.3115 39 47.3115C40.1202 47.3115 41.0283 46.4034 41.0283 45.2832C41.0283 44.163 40.1202 43.2549 39 43.2549C37.8798 43.2549 36.9717 44.163 36.9717 45.2832Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0566 45.2832C43.0566 47.5236 41.2404 49.3398 39 49.3398C36.7596 49.3398 34.9434 47.5236 34.9434 45.2832C34.9434 43.0428 36.7596 41.2266 39 41.2266C41.2404 41.2266 43.0566 43.0428 43.0566 45.2832ZM36.9717 45.2832C36.9717 46.4034 37.8798 47.3115 39 47.3115C40.1202 47.3115 41.0283 46.4034 41.0283 45.2832C41.0283 44.163 40.1202 43.2549 39 43.2549C37.8798 43.2549 36.9717 44.163 36.9717 45.2832Z",
    fill: "#161614",
    stroke: "#161614",
    strokeWidth: 0.162266,
    mask: "url(#path-7-inside-2_75_1436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8164 33.4219L21.1731 33.5853",
    stroke: "#F30002",
    strokeWidth: 3.19316,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6035,
    cy: 33.5996,
    r: 4.05664,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6602 33.5996C27.6602 35.84 25.8439 37.6562 23.6035 37.6562C21.3631 37.6562 19.5469 35.84 19.5469 33.5996C19.5469 31.3592 21.3631 29.543 23.6035 29.543C25.8439 29.543 27.6602 31.3592 27.6602 33.5996ZM21.5752 33.5996C21.5752 34.7198 22.4833 35.6279 23.6035 35.6279C24.7237 35.6279 25.6318 34.7198 25.6318 33.5996C25.6318 32.4794 24.7237 31.5713 23.6035 31.5713C22.4833 31.5713 21.5752 32.4794 21.5752 33.5996Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.be6eea24807cc0d3e5baa0d042ea0fe7.svg";
export { ForwardRef as ReactComponent };